export default {
  path: 'working-places',
  name: 'PersonWorkingPlaces',
  component: () => import(/* webpackChunkName: "people" */ '../views/PersonWorkingPlacesView.vue')
}
